module.exports = __webpack_public_path__ + "img/actuar-de-oficio.853ef688.png";